import React from 'react';
import { Link } from 'react-router-dom';
import { useProducts } from '../context/ProductContext';
import { LaptopIcon, CircleDollarSignIcon, MonitorIcon } from 'lucide-react';
export const CategorySection: React.FC = () => {
  const {
    categories
  } = useProducts();
  // Map of category icons
  const categoryIcons: Record<string, React.ReactNode> = {
    electronics: <MonitorIcon className="w-10 h-10 text-green-500" data-id="element-35" />,
    gold: <CircleDollarSignIcon className="w-10 h-10 text-yellow-500" data-id="element-36" />,
    silver: <CircleDollarSignIcon className="w-10 h-10 text-gray-400" data-id="element-37" />,
    platinum: <CircleDollarSignIcon className="w-10 h-10 text-gray-600" data-id="element-38" />,
    'technical-tools': <LaptopIcon className="w-10 h-10 text-blue-500" data-id="element-39" />,
    accessories: <LaptopIcon className="w-10 h-10 text-purple-500" data-id="element-40" />
  };
  return <section className="py-12 bg-white dark:bg-gray-900" data-id="element-41">
      <div className="container mx-auto px-4" data-id="element-42">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 dark:text-white mb-8" data-id="element-43">
          Shop by Category
        </h2>
        <p className="text-center text-gray-600 dark:text-gray-400 max-w-2xl mx-auto mb-10" data-id="element-44">
          Explore our curated selection of premium products
        </p>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6" data-id="element-45">
          {categories.map(category => <Link key={category.id} to={`/category/${category.id}`} className="bg-white dark:bg-gray-800 rounded-lg p-6 text-center shadow-md hover:shadow-lg transition-shadow duration-300" data-id="element-46">
              <div className="flex justify-center mb-4" data-id="element-47">
                {categoryIcons[category.id] || <CircleDollarSignIcon className="w-10 h-10 text-gray-500" data-id="element-48" />}
              </div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2" data-id="element-49">
                {category.name}
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-50">
                {category.description}
              </p>
              <button className="mt-4 text-sm font-medium text-yellow-500 hover:text-yellow-600 dark:hover:text-yellow-400" data-id="element-51">
                Browse {category.name} →
              </button>
            </Link>)}
        </div>
      </div>
    </section>;
};